import { render } from "./FooterBar.vue?vue&type=template&id=7fcb3425&scoped=true"
const script = {}

import "@/assets/style/mainpage.css?vue&type=style&index=0&id=7fcb3425&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fcb3425"]])

export default __exports__